import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import globalStyle from "../../globalStyle";

const CustomSelect = ({
  icon,
  children,
  placeholder,
  formStyleProps = {},
  inputError,
  helperText,
  size = "small",
  ...props
}) => {
  return (
    <FormControl
      fullWidth
      error={inputError}
      size={size}
      sx={{ ...formStyleProps, ...globalStyle.customSelect }}
    >
      <InputLabel>{placeholder}</InputLabel>
      <Select
        startAdornment={
          icon && <InputAdornment position="start">{icon}</InputAdornment>
        }
        {...props}
        label={placeholder}
        size={size || "small"}
      >
        {children}
      </Select>
      {inputError && (
        <FormHelperText error sx={{ marginLeft: 0 }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomSelect;
